/*
 * PLP 商品カード: Swym お気に入りボタンを商品画像ボックス (.card__inner.ratio) の中へ移動する。
 * ─ Swym はカードの外側 (価格の下など) にボタンを注入するため、画像内の右下に置けない。
 * ─ このスクリプトで各カードの画像ボックス内へ移動し、CSS で右下に絶対配置する。
 * ─ Swym は非同期でボタンを注入するため、MutationObserver + 遅延実行で追従する。
 */
(function () {
  'use strict';

  function place(btn) {
    var card = btn.closest('.card-wrapper, .card');
    if (!card) return;
    // 画像ボックス (.card__inner.ratio) を優先。無ければ .card__inner / .card__media
    var box =
      card.querySelector('.card__inner.ratio') ||
      card.querySelector('.card__inner') ||
      card.querySelector('.card__media');
    if (box && btn.parentElement !== box) {
      box.appendChild(btn); // イベントリスナーは保持したまま移動される
    }
  }

  function run() {
    document
      .querySelectorAll('.swym-advanced-wishlist-collections-container')
      .forEach(place);
  }

  run();

  // Swym の非同期注入 / 再描画に追従
  if (window.MutationObserver) {
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1) continue;
          if (
            (n.matches && n.matches('.swym-advanced-wishlist-collections-container')) ||
            (n.querySelector && n.querySelector('.swym-advanced-wishlist-collections-container'))
          ) {
            run();
            return;
          }
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  // 遅延注入の保険
  window.addEventListener('load', run);
  window.setTimeout(run, 1500);
  window.setTimeout(run, 3500);
})();
